import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1e879178")

_pushScopeId("data-v-1e879178")
const _hoisted_1 = { class: "multiple" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = { class: "a-checkbox" }
const _hoisted_4 = {
  key: 1,
  class: "content"
}
const _hoisted_5 = { class: "a-checkbox" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.jobView === "preview")
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_a_checkbox_group, {
            value: _ctx.answer,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.answer = $event))
          }, {
            default: _withId(() => [
              _createVNode(_component_a_row, null, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pMetas, (meta, i) => {
                    return (_openBlock(), _createBlock(_component_a_col, {
                      span: 12,
                      key: meta.uid
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_a_checkbox, { value: i }, null, 8, ["value"]),
                        _createVNode("div", _hoisted_3, _toDisplayString(meta.meta), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_a_checkbox_group, {
            value: _ctx.todoStu,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.todoStu = $event)),
            onChange: _ctx.todoSave,
            disabled: _ctx.jobView === 'see'
          }, {
            default: _withId(() => [
              _createVNode(_component_a_row, null, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pMetas, (meta, i) => {
                    return (_openBlock(), _createBlock(_component_a_col, {
                      span: 12,
                      key: meta.uid
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_a_checkbox, { value: i }, null, 8, ["value"]),
                        _createVNode("div", _hoisted_5, _toDisplayString(meta.meta), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "onChange", "disabled"])
        ]))
  ]))
})